import React, { useState, useEffect } from "react";
import { useAuth } from "./AuthContext"; // Import useAuth from AuthContext
import '../styles/styles.css';
import SalesForm from "./SalesForm";
import MenuBar from './TopLeftMenu';
import styled from "styled-components";
import { fetchLeadsToSalesCountByEmail, fetchAvoidableLossCountByEmail, fetchPUMCountByEmail, 
  fetchPMSalesConversionsCountByEmail, fetchPUMsUnderByEmail, fetchTableDataFromHRSync
 } from "../services/airtable";

const RowContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: ${(props) => (props.isSecondRow ? "-20px -15px" : "0 -15px")};

 @media (max-width: 480px) {
     flex-direction: column;
     margin: 0;
   }
`;

const AddButton = styled.button`
  position: absolute;
  top: 0px;
  right: 45px;
  display: none;
  background: rgb(105, 109, 105);
  color: white;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: #388e3c;
  }
`;

const UpdateButton = styled.button`
  position: absolute;
  top: 0px;
  right: 80px;
  display: none;
  background: #ffa726;
  color: white;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: #fb8c00;
  }
`;

const RemoveButton = styled.button`
  position: absolute;
  top: 0px;
  right: 10px;
  display: none;
  background: #ff4d4f;
  color: white;
  border: none;
  border-radius: 50%;
  width: 25px;
  height: 28px;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: #d9363e;
  }
`;

const GaugeContainer = styled.div`
  position: relative;
  top: 25px;
  width: ${(props) =>
    props.isSecondRow
      ? props.size === "mediumLarge"
        ? "270px"
        : "2500px"
      : props.size === "large"
      ? "300px"
      : props.size === "mediumLarge"
      ? "240px"
      : "280px"};
  height: ${(props) =>
    props.isSecondRow
      ? props.size === "mediumLarge"
        ? "270px"
        : "250px"
      : props.size === "large"
      ? "300px"
      : props.size === "mediumLarge"
      ? "240px"
      : "200px"};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
order: ${(props) => (props.isMobile ? (props.gaugeIndex === 1 ? -1 : 0) : 0)};

  @media (max-width: 480px) {
    order: ${(props) => (props.gaugeIndex === 1 ? -1 : 0)};
  }
  @media (max-width: 545px) {
     order: ${(props) =>
       props["data-gauge-index"] === 1 ? -1 : props["data-gauge-index"] === 0 ? 0 : 1};
   }

  &:hover .remove-button {
    display: flex;
  }
  &:hover .add-button {
    display: flex;
  } 
  &:hover .update-button {
    display: flex;
  }

  margin: ${(props) =>
    props.isSecondRow ? "2 0px 30px" : "10px -0px"};
`;

const CenteredContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-family: "Arial", sans-serif;
  color: #333;

  .title {
    font-size: ${(props) =>
      props.title === ""
        ? "2.5rem"
        : props.size === "large"
        ? "1.1rem"
        : "0.75rem"}; 
    font-weight: bold;
    line-height: 1.2; 
    color: #333;
    text-align: center;
    word-wrap: break-word;
  }

  .number {
    font-size: ${(props) =>
      props.title === ""
        ? "2.5rem"
        : props.size === "large"
        ? "2.2rem"
        : "1.4rem"};
    font-weight: bold;
    margin-top: ${(props) =>
      props.title === "Live Listings" ? "0px" : "10px"}; 
    color: #f7941d; 
    position: absolute;
    bottom: ${(props) =>
      props.title === "Leads to Sales"
        ? "-70px"
        : props.title === "Portfolio #"
        ? "-100px"
        : props.title === "NSR"
        ? "-70px"
        : props.title === "Avoidable Loss"
        ? "-70px"
        : props.title === "Sales Conversions"
        ? "-70px"
        : props.title === "PUM's Referral"
        ? "-60px"
        : props.gaugeIndex >= 1 && props.gaugeIndex <= 3
        ? "-60px"
        : "-50px"};
  }

  .text-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .line-break {
    margin-top: 0.3rem;
  }
`;

const formatNumberForDisplay = (number) => {
  if (typeof number === "number" || !isNaN(number)) {
      const parsedNumber = parseFloat(number);

      if (parsedNumber >= 1000000) {
          const value = parsedNumber / 1000000;
          return Number.isInteger(value) ? `${value}M` : `${value.toFixed(1)}M`;
      } else if (parsedNumber >= 1000) {
          const value = parsedNumber / 1000;
          return Number.isInteger(value) ? `${value}k` : `${value.toFixed(1)}k`;
      }
  }
  return number;
};

const generateYellowArc = (rangeFrom, rangeTo, value, adjustedRadius, circleCenter, gaugeIndex) => {
  if (gaugeIndex === 22) {
    value = Math.max(1, Math.min(value, 3));
    rangeFrom = 1; 
    rangeTo = 3; 

    if (value === 1) {
      const startAngle = 130;
      const endAngle = 181;

      const startRadian = (startAngle * Math.PI) / 180;
      const endRadian = (endAngle * Math.PI) / 180;

      const startX = circleCenter + adjustedRadius * Math.cos(startRadian);
      const startY = circleCenter + adjustedRadius * Math.sin(startRadian);
      const endX = circleCenter + adjustedRadius * Math.cos(endRadian);
      const endY = circleCenter + adjustedRadius * Math.sin(endRadian);
      const largeArcFlag = 0; 

      return `M ${startX} ${startY} A ${adjustedRadius} ${adjustedRadius} 0 ${largeArcFlag} 1 ${endX} ${endY}`;
    }

    if (value === 3) {
      const startAngle = 130;
      const endAngle = 360;
      const startRadian = (startAngle * Math.PI) / 180;
      const endRadian = (endAngle * Math.PI) / 180;

      const startX = circleCenter + adjustedRadius * Math.cos(startRadian);
      const startY = circleCenter + adjustedRadius * Math.sin(startRadian);
      const endX = circleCenter + adjustedRadius * Math.cos(endRadian);
      const endY = circleCenter + adjustedRadius * Math.sin(endRadian);

      const largeArcFlag = 1;

      return `M ${startX} ${startY} A ${adjustedRadius} ${adjustedRadius} 0 ${largeArcFlag} 1 ${endX} ${endY}`;
    }
  }

  const totalRange = rangeTo - rangeFrom;

  const startAngle = 135; 
  let endAngle = 135 + ((value - rangeFrom) / totalRange) * 270;

  endAngle = Math.min(endAngle, 405);

  const startRadian = (startAngle * Math.PI) / 180;
  const endRadian = (endAngle * Math.PI) / 180;
  const startX = circleCenter + adjustedRadius * Math.cos(startRadian);
  const startY = circleCenter + adjustedRadius * Math.sin(startRadian);
  const endX = circleCenter + adjustedRadius * Math.cos(endRadian);
  const endY = circleCenter + adjustedRadius * Math.sin(endRadian);
  const largeArcFlag = endAngle - startAngle > 180 ? 1 : 0;

  return `M ${startX} ${startY} A ${adjustedRadius} ${adjustedRadius} 0 ${largeArcFlag} 1 ${endX} ${endY}`;
};

const CircularGauge = ({
  title,
  number,
  size,
  isSecondRow,
  gaugeIndex,
  onRemove,
  onUpdate,
  onAdd,
  rangeFrom,
  rangeTo,
  interval,
  tickMarks,
}) => {
  const radius = size === "large" ? 90 : size === "mediumLarge" ? 85 : 75;
  const adjustedRadius = isSecondRow ? radius + 5 : radius;
  const circleCenter = 100;

  const renderTicks = () => {
      const ticks = [];
      const numbers = [];
      const startAngle = 135;
      const endAngle = 405;
      const totalTicks = Math.floor((rangeTo - rangeFrom) / interval) + 1;
      const angleIncrement = (endAngle - startAngle) / (totalTicks - 1);
      const isCompactMode = totalTicks >= 25;
      const numberFontSize = isCompactMode ? 8 : 10;
      const tickGap = isCompactMode ? 10 : 15;
      const numberGap = isCompactMode ? 20 : 28;

      for (let i = 0; i < totalTicks; i++) {
          const value = rangeFrom + i * interval;
          const angle = startAngle + i * angleIncrement;
          const radian = (angle * Math.PI) / 180;
          const x1 = circleCenter + (adjustedRadius - 2) * Math.cos(radian);
          const y1 = circleCenter + (adjustedRadius - 2) * Math.sin(radian);
          const x2 = circleCenter + (adjustedRadius - tickGap) * Math.cos(radian);
          const y2 = circleCenter + (adjustedRadius - tickGap) * Math.sin(radian);

          ticks.push(
              <line
                  key={`tick-${i}`}
                  x1={x1}
                  y1={y1}
                  x2={x2}
                  y2={y2}
                  stroke="#000"
                  strokeWidth={i % Math.floor(totalTicks / tickMarks) === 0 ? "2" : "1"}
              />
          );

          const xText = circleCenter + (adjustedRadius - numberGap) * Math.cos(radian);
          const yText = circleCenter + (adjustedRadius - numberGap) * Math.sin(radian);

          numbers.push(
              <text
                  key={`number-${i}`}
                  x={xText}
                  y={yText}
                  fontSize={numberFontSize}
                  textAnchor="middle"
                  fill="#333"
                  fontFamily="Arial"
              >
                  {formatNumberForDisplay(value)}
              </text>
          );
      }

      return { ticks, numbers };
  };

  const { ticks, numbers } = renderTicks();
  const parsedNumber = parseFloat(
    String(number).replace(/[^0-9.]/g, "")
  ) * (String(number).includes("M") ? 1e6 : 1);
  
  const clampedNumber = Math.min(Math.max(parsedNumber, rangeFrom), rangeTo);

  const yellowArcPath = generateYellowArc(
    rangeFrom,
    rangeTo,
    clampedNumber,
    adjustedRadius,
    circleCenter,
    gaugeIndex 
  );

  const formattedTitle = [
      "Core Market",
      "Image Ranking",
      "PUM's Referral",
      "Lead Conversion",
      "Office Ranking",
      "PUM's in Core",
      "Live Listings",
  ].includes(title)
      ? title.split(" ")
      : [title];

  return (
      <GaugeContainer size={size} isSecondRow={isSecondRow}>
          <RemoveButton className="remove-button" onClick={onRemove}>
              ×
          </RemoveButton>
          <AddButton className="add-button" onClick={onAdd}>
              +
          </AddButton>
          <UpdateButton className="update-button" onClick={() => onUpdate(gaugeIndex)}>
              ✎
          </UpdateButton>
          <svg width="100%" height="100%" viewBox="0 0 200 200">
              <defs>
                  <mask id={`gaugeMask-${gaugeIndex}`}>
                      <rect x="0" y="0" width="200" height="200" fill="white" />
                      <rect
                          x="0"
                          y={
                              gaugeIndex === 0 && title === "Core Market"
                                  ? 1.5
                                  : gaugeIndex === 1
                                  ? 163.5
                                  : isSecondRow
                                  ? 157
                                  : 160
                          }
                          width="300"
                          height="100"
                          fill="black"
                      />
                  </mask>
              </defs>
              <circle
                  cx={circleCenter}
                  cy={circleCenter}
                  r={adjustedRadius}
                  fill="none"
                  stroke="#e0e0e0"
                  strokeWidth="3"
                  mask={`url(#gaugeMask-${gaugeIndex})`}
              />
             {yellowArcPath && (
          <path
            d={yellowArcPath}
            fill="none"
            stroke="#f7941d"
            strokeWidth="3"
          />
        )}
              {ticks}
              {numbers}
          </svg>
          <CenteredContent size={size} title={title}>
              <div className="text-container">
                  <div className="title">
                      {formattedTitle.map((line, index) => (
                          <div key={index}>{line}</div>
                      ))}
                  </div>
                  <div className="number">
                      {formatNumberForDisplay(number)}
                  </div>
              </div>
          </CenteredContent>
      </GaugeContainer>
  );
};

const PM = ({ userEmail }) => {
  const { user } = useAuth(); // Use the useAuth hook to get the authenticated user
  const [isMobile, setIsMobile] = useState(false);
  const [gauges, setGauges] = useState([
    { title: "Leads to Sales", number: "0", size: "mediumLarge", rangeFrom: 0, rangeTo: 110, interval: 10, tickMarks: 20 },
    { title: "Portfolio #", number: "0", size: "large", rangeFrom: 0, rangeTo: 1000, interval: 100, tickMarks: 20 },
    { title: "Avoidable Loss", number: "0", size: "mediumLarge", rangeFrom: 0, rangeTo: 110, interval: 10, tickMarks: 20 },
    { title: "Sales Conversions", number: "0", size: "medium", rangeFrom: 0, rangeTo: 110, interval: 10, tickMarks: 20 },
    { title: "PUM's Referral", number: "0", size: "medium", rangeFrom: 0, rangeTo: 110, interval: 10, tickMarks: 20 },
  ]);

  const [showPopup, setShowPopup] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [currentGaugeIndex, setCurrentGaugeIndex] = useState(null);
  const [gaugePopupData, setGaugePopupData] = useState({
    rangeFrom: 0,
    rangeTo: 100,
    interval: 10,
    tickMarks: 5,
  });

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const fetchLeadsAndAvoidableLossCount = async () => {
      try {
        if (!userEmail) {
          console.error("User email is not provided");
          return;
        }

        const { totalCount: leadsToSalesCount } = await fetchLeadsToSalesCountByEmail(userEmail);
        const { totalCount: avoidableLossCount } = await fetchAvoidableLossCountByEmail(userEmail);
        const { count: salesConversionsCount } = await fetchPMSalesConversionsCountByEmail(userEmail);

        setGauges((prevGauges) =>
          prevGauges.map((gauge, index) => {
            if (gauge.title === "Leads to Sales" && index === 0) {
              return { ...gauge, number: leadsToSalesCount.toString() };
            } else if (gauge.title === "Avoidable Loss" && index === 2) {
              return { ...gauge, number: avoidableLossCount.toString() };
            } else if (index === 3) {
              return { ...gauge, number: salesConversionsCount.toString() };
            }
            return gauge;
          })
        );

        const pumReferral = await fetchPUMCountByEmail(userEmail);
        if (pumReferral) {
          const totalPUMReferrals = pumReferral.count;
          setGauges((prevGauges) =>
            prevGauges.map((gauge, index) => {
              if (
                (index === 4 || gauge.text === "PUM's Referral") &&
                !React.isValidElement(gauge)
              ) {
                return {
                  ...gauge,
                  number:
                    totalPUMReferrals !== undefined && totalPUMReferrals !== null
                      ? totalPUMReferrals
                      : "N/A",
                };
              }
              return gauge;
            })
          );
        }

        const portfolioSum = await fetchPUMsUnderByEmail(userEmail);
        if (portfolioSum !== undefined && portfolioSum !== null) {
          setGauges((prevGauges) =>
            prevGauges.map((gauge, index) => {
              if (
                (index === 1 || gauge.title === "Portfolio #") &&
                !React.isValidElement(gauge)
              ) {
                return {
                  ...gauge,
                  number:
                    portfolioSum !== undefined && portfolioSum !== null
                      ? portfolioSum
                      : "N/A",
                };
              }
              return gauge;
            })
          );
        }
      } catch (error) {
        console.error("Error fetching Leads to Sales or Avoidable Loss count:", error);
      }
    };

    fetchLeadsAndAvoidableLossCount();
  }, [userEmail]);

  const handleAdd = (index) => {
    setIsUpdating(false);
    setShowPopup(true);
    setCurrentGaugeIndex(index);
    setGaugePopupData({
      rangeFrom: 0,
      rangeTo: 100,
      interval: 10,
      tickMarks: 5,
      title: "",
      number: "",
    });
  };

  const handleRemove = (index) => {
    const updatedGauges = gauges.filter((_, i) => i !== index);
    setGauges(updatedGauges);
  };

  const handleUpdate = (index) => {
    setIsUpdating(true);
    setShowPopup(true);
    setCurrentGaugeIndex(index);
    setGaugePopupData(gauges[index]);
  };

  const handleSubmitNewGauge = (formData) => {
    const { title, number, rangeFrom, rangeTo, interval, tickMarks } = formData;

    if (isUpdating && currentGaugeIndex !== null) {
      const updatedGauges = [...gauges];
      updatedGauges[currentGaugeIndex] = {
        ...updatedGauges[currentGaugeIndex],
        title,
        number,
        rangeFrom: parseInt(rangeFrom, 10),
        rangeTo: parseInt(rangeTo, 10),
        interval: parseInt(interval, 10),
        tickMarks: parseInt(tickMarks, 10),
      };
      setGauges(updatedGauges);
    } else {
      const baseGauge = gauges[currentGaugeIndex] || {};
      const newGauge = {
        title: title || "New Gauge",
        number: number || "0",
        size: baseGauge.size || "medium",
        rangeFrom: parseInt(rangeFrom, 10),
        rangeTo: parseInt(rangeTo, 10),
        interval: parseInt(interval, 10),
        tickMarks: parseInt(tickMarks, 10),
      };

      const updatedGauges = [...gauges];
      const insertIndex = currentGaugeIndex !== null ? currentGaugeIndex + 1 : gauges.length;
      updatedGauges.splice(insertIndex, 0, newGauge);
      setGauges(updatedGauges);
    }

    setShowPopup(false);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const mobileOrder = ["Portfolio #", "Leads to Sales", "NSR"];
  const sortedGauges = isMobile
    ? [...gauges].sort(
        (a, b) => mobileOrder.indexOf(a.title) - mobileOrder.indexOf(b.title)
      )
    : gauges;

  return (
    <>
      <RowContainer>
        {gauges.slice(0, 3).map((gauge, index) => (
          <GaugeContainer
            key={index}
            size={gauge.size}
            data-gauge-index={index === 2 ? 0 : index === 1 ? 1 : index === 0 ? 2 : index}
          >
            <CircularGauge
              {...gauge}
              gaugeIndex={index}
              onRemove={() => handleRemove(index)}
              onAdd={() => handleAdd(index)}
              onUpdate={() => handleUpdate(index)}
            />
          </GaugeContainer>
        ))}
      </RowContainer>
      <RowContainer isSecondRow>
        {gauges.slice(3).map((gauge, index) => (
          <GaugeContainer key={index + 3} size={gauge.size} data-gauge-index={index}>
            <CircularGauge
              {...gauge}
              gaugeIndex={index + 3}
              isSecondRow
              onRemove={() => handleRemove(index + 3)}
              onAdd={() => handleAdd(index + 3)}
              onUpdate={() => handleUpdate(index + 3)}
            />
          </GaugeContainer>
        ))}
      </RowContainer>
      {showPopup && (
        <SalesForm
          onSubmit={(formData) => handleSubmitNewGauge(formData)}
          onClose={handleClosePopup}
          formData={gaugePopupData}
          isUpdateMode={isUpdating}
        />
      )}
    </>
  );
};

export default PM;